export type ValuesOf<T> = T extends boolean | string | number
  ? never
  : number extends keyof T
  ? T[number]
  : T[keyof T];

export type Include<T, U> = Exclude<T, Exclude<T, U>>;

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const expectAssignable = <T>(_: T) => {
  // do nothing
};
